import { create } from 'zustand';

interface ConnectEmailPromptState {
  isOpen: boolean;
}

interface ConnectEmailPromptActions {
  open: () => void;
  close: () => void;
}

type ConnectEmailPromptStore = ConnectEmailPromptState &
  ConnectEmailPromptActions;

export const useConnectEmailPromptStore = create<ConnectEmailPromptStore>(
  (set) => ({
    isOpen: false,
    open: () => set({ isOpen: true }),
    close: () => set({ isOpen: false }),
  }),
);
